import searchIcon from "@assets/search/search_icon.webp";
import { isSameOrigin, prefixCheck } from "@helper/utils";
import { ChangeEvent, KeyboardEvent, SubmitEvent, useState } from "react";
import { twMerge } from "tailwind-merge";

type SearchInputProps = {
  expanded: boolean;
  className?: string;
  initSearchValue?: string;
  onScroll?: boolean;
};

export function SearchInput({
  expanded,
  className,
  initSearchValue = "",
  onScroll,
}: SearchInputProps) {
  const [searchValue, setSearchValue] = useState(initSearchValue);

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setSearchValue(event.target.value);
  };

  const handleSearch = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      if (!searchValue.trim()) return;
      if (prefixCheck(searchValue)) return;
      if (!isSameOrigin(window.origin)) return;
      window.location.href = `/search/site/${encodeURIComponent(searchValue)}`;
    }
  };

  const handleSubmit = (event: SubmitEvent<HTMLFormElement>) => {
    event.preventDefault();
    event.stopPropagation();
    if (!searchValue.trim()) return;
    if (prefixCheck(searchValue)) return;
    if (!isSameOrigin(window.origin)) return;
    window.location.href = `/search/site/${encodeURIComponent(searchValue)}`;
  };

  return (
    <>
      {expanded ? (
        <div
          data-testid="search"
          className={twMerge(
            "bg-yellow-100 h-10 xmd:h-xxl",
            className,
            onScroll &&
              "sticky z-[9] transition-all duration-500 ease-in-out top-xxl",
          )}
        >
          <div
            data-testid="searchExpanded"
            className="text-center border-none xmd:max-w-[1440px] xmd:px-[121px] mx-auto py-0.5 xmd:py-1.5 h-9 xmd:h-12"
          >
            <form
              onSubmit={handleSubmit}
              className="flex h-9 xmd:h-12 px-4 xmd:px-0"
            >
              <input
                type="text"
                placeholder="Search for..."
                value={searchValue}
                onChange={handleInputChange}
                onKeyDown={handleSearch}
                className="flex-auto px-2 md:px-4 h-9 xmd:h-12 outline-none text-lg text-gray-1000 font-opensans font-normal placeholder-grey-200"
                maxLength={100}
                autoCorrect="off"
                autoCapitalize="off"
                autoComplete="off"
                spellCheck="false"
                style={{
                  backgroundImage: `url(${searchIcon})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "calc(100% - 8px) center",
                  backgroundSize: "24px",
                }}
              />
            </form>
          </div>
        </div>
      ) : null}
    </>
  );
}
